import {
  type DropTargetDropEvent,
  type DropTargetOptions,
  useDropTarget,
} from '@hive/component';
import type { HiveDNDData } from '@hive/core/types/dnd';
import { useI18n } from '@hive/i18n';

import { EmptyNodeChildren } from '../../layouts/empty-node-children';
import { draggedOverHighlight } from './empty.css';

export const FolderEmpty = ({
  canDrop,
  onDrop,
}: {
  onDrop?: (data: DropTargetDropEvent<HiveDNDData>) => void;
  canDrop?: DropTargetOptions<HiveDNDData>['canDrop'];
}) => {
  const { dropTargetRef } = useDropTarget(
    () => ({
      onDrop,
      canDrop,
    }),
    [onDrop, canDrop]
  );

  const t = useI18n();
  return (
    <EmptyNodeChildren ref={dropTargetRef} className={draggedOverHighlight}>
      {t['com.hive.rootAppSidebar.organize.empty-folder']()}
    </EmptyNodeChildren>
  );
};
